export default "__VITE_ASSET__08df4c2d__"